import {combineReducers} from 'redux';
// @ts-expect-error
import {createReducer} from 'redux-act';
import {REHYDRATE} from 'redux-persist';

import * as Schema from 'nutshell-core/schema';
import type {ListItem} from 'nutshell-core/types';

import {simpleHydrate} from '../../../master-dashboard/dashboard-reducer';

import * as actions from './companies-actions';

type McfxCompaniesListState = {
    isLoading: boolean;
    isFirstLoad: boolean;
    errorMessage?: string;
    listItems: any[];
    meta: any;
};

const mcfxCompaniesListDefaultState = {
    isLoading: true,
    isFirstLoad: true,
    errorMessage: undefined,
    listItems: [],
    meta: {},
} as const;

const isFilterDrawerOpen = createReducer(
    {
        // @ts-expect-error
        [actions.toggleShowFilterDrawer]: (state) => !state,
    },
    false
);

export const mcfxCompaniesListReducer = createReducer(
    {
        // @ts-expect-error
        [actions.requestMcfxCompaniesListData]: (state) => {
            return {...state, isLoading: true, errorMessage: undefined};
        },
        // @ts-expect-error
        [actions.updateMcfxCompaniesListData]: (state, {meta, listItems}) => {
            return {
                ...state,
                isLoading: false,
                isFirstLoad: false,
                meta: meta,
                listItems: listItems
                    ? listItems.map((item: ListItem) => {
                          return {
                              ...item,
                              id: item.links ? item.links.entity.id : item.id,
                          };
                      })
                    : undefined,
                errorMessage: undefined,
            };
        },
        // @ts-expect-error
        [actions.failMcfxCompaniesListData]: (state, err) => {
            return {...state, isLoading: false, isFirstLoad: false, errorMessage: err};
        },
    },
    mcfxCompaniesListDefaultState
);

export const mcfxCompaniesSchemaReducer = createReducer(
    {
        // @ts-expect-error
        [actions.updateMcfxCompaniesSchema]: (state, payload) => payload,
        // @ts-expect-error
        [REHYDRATE]: (state, persistedState) =>
            simpleHydrate(state, persistedState, 'mcfxCompaniesSchema'),
    },
    {}
);

export const mcfxCompaniesReducer = combineReducers({
    mcfxCompaniesList: mcfxCompaniesListReducer,
    mcfxCompaniesSchema: mcfxCompaniesSchemaReducer,
    isFilterDrawerOpen,
});

export type McfxCompaniesState = {
    mcfxCompaniesList: McfxCompaniesListState;
    mcfxCompaniesSchema: Schema.Properties;
    isFilterDrawerOpen: boolean;
};
